import { ReleaseNotes } from "../../components/ReleaseNotes/ReleaseNotes";

export default function ReleaseNotesPage() {
    return (
        
            <ReleaseNotes />
        
    );
}
